import React from 'react';
import { ActionIcon, Flex, Menu, Tooltip } from '@mantine/core';
import { IconCopy, IconEdit, IconEye, IconTrash } from '@tabler/icons-react';

interface TableActionMenuProps {
  data: any;
  viewText?: string;
  deleteText?: string;
  editText?: string;
  copyText?: string;
  handleView?: (_data: any) => void;
  handleEdit?: (_data: any) => void;
  handleDelete?: (_data: any) => void;
  handleCopy?: (_data: any) => void;
}

const TableActionMenu: React.FC<TableActionMenuProps> = ({
  handleDelete,
  handleEdit,
  handleView,
  handleCopy,
  viewText,
  deleteText,
  editText,
  copyText,
  data
}) => {
  return (
    <Menu shadow='md'>
      <Flex gap={4}>
        {handleCopy && (
          <Tooltip label={copyText}>
            <ActionIcon variant='transparent' c={'grey.5'} onClick={() => handleCopy(data)}>
              <IconCopy />
            </ActionIcon>
          </Tooltip>
        )}
        {handleView && (
          <Tooltip label={viewText}>
            <ActionIcon variant='transparent' c={'grey.5'} onClick={() => handleView(data)}>
              <IconEye />
            </ActionIcon>
          </Tooltip>
        )}
        {handleEdit && (
          <Tooltip label={editText}>
            <ActionIcon variant='transparent' c={'grey.5'} onClick={() => handleEdit(data)}>
              <IconEdit />
            </ActionIcon>
          </Tooltip>
        )}
        {handleDelete && (
          <Tooltip label={deleteText}>
            <ActionIcon variant='transparent' c={'grey.5'} onClick={() => handleDelete(data)}>
              <IconTrash />
            </ActionIcon>
          </Tooltip>
        )}
      </Flex>
    </Menu>
  );
};

export default TableActionMenu;
